import { useEffect, useState } from 'react';

const DEFAULT_COVER =
	'https://res.cloudinary.com/inuk/image/upload/v1750255083/inuk/IGLU/usptbumtdwhypmghqxy3.jpg';

export const useValidImage = (url?: string) => {
	const [validUrl, setValidUrl] =
		useState<string>(DEFAULT_COVER);

	useEffect(() => {
		if (!url) {
			setValidUrl(DEFAULT_COVER);
			return;
		}

		const img = new Image();
		img.src = url;

		img.onload = () => setValidUrl(url);
		img.onerror = () => setValidUrl(DEFAULT_COVER);

		// cleanup
		return () => {
			img.onload = null;
			img.onerror = null;
		};
	}, [url]);

	return validUrl;
};
